var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 37,
    rx: 18,
    fill: "#C1E2FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7148 18.75C25.7148 19.3828 25.2227 19.875 24.625 19.875H13.832L17.5234 23.6016C17.9805 24.0234 17.9805 24.7617 17.5234 25.1836C17.3125 25.3945 17.0312 25.5 16.75 25.5C16.4336 25.5 16.1523 25.3945 15.9414 25.1836L10.3164 19.5586C9.85938 19.1367 9.85938 18.3984 10.3164 17.9766L15.9414 12.3516C16.3633 11.8945 17.1016 11.8945 17.5234 12.3516C17.9805 12.7734 17.9805 13.5117 17.5234 13.9336L13.832 17.625H24.625C25.2227 17.625 25.7148 18.1523 25.7148 18.75Z",
    fill: "#C1E2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.2bfbbd467168623cfa91bfaa8059c07c.svg";
export { ForwardRef as ReactComponent };